// import * as React from "react";
// import Icon from "../Icon/";
// import LinkComp from "../LinkComp";
// import svgBuyers from "../../svgs/Buyers.svg";
// import svgStats from "../../svgs/Stats.svg";
// import svgProperties from "../../svgs/Properties.svg";
// import svgSellers from "../../svgs/Sellers.svg";
// import svgAgents from "../../svgs/Agents.svg";
// import svgFirms from "../../svgs/Firms.svg";
// import svgTenants from "../../svgs/Tenants.svg";
// import svgLenders from "../../svgs/Lenders.svg";
// import svgUploads from "../../svgs/Upload.svg";
// import svgSignout from "../../svgs/Signout.svg";
// import svgExpand from "../../svgs/Expand.svg";
// import svgCollapse from "../../svgs/collapse.svg";
// import svgStrivePipeline from "../../svgs/StrivePipeline.svg";
// import svgAgentCommissionBreakdown from "../../svgs/AgentCommissionBreakout.svg";
// import svgAgentPipeline from "../../svgs/AgentPipeline.svg";
// import svgBuckets from "../../svgs/Buckets.svg";
// import svgInventory from "../../svgs/Inventory.svg";
// import svgEscrowTracking from "../../svgs/EscrowTracking.svg";
// import svgPipeline from "../../svgs/Pipeline.svg";
// import svgStriveFees from "../../svgs/Fees.svg";
// import svgHscPipeline from "../../svgs/HscPipeline.svg";
// import svgHscTracking from "../../svgs/HSCTracking.svg";
// import svgTrainingPages from "../../svgs/TrainingPages.svg";
// import plus from '../../svgs/plus-dark.svg';
// import PipelineDropdown from "../PipelineDropdown/PipelineDropdown";
// import svgHsc from "../../svgs/HSC.svg";
// import svgTeamMembers from "../../svgs/TeamMembers.svg";
// import svgEyeOpen from "../../svgs/StriveVision.svg";
// import svgCRM from "../../svgs/CRM.svg"
// import svgContacts from "../../svgs/Contacts.svg"
// import svgCompany from "../../svgs/Company.svg"

// const getLinks = (isSuper) => {
//     return [{
//             name: "Properties",
//             listPath: "list?source=STRIVE&status=Active&transaction_type=Investment+Sales",
//             // SOURCE=STRIVE&STATUS=Active&TRANSACTION_TYPE=Investment+Sales",
//             newPath: "property",
//             superOnly: false,
//             svg: svgProperties,
//         }, {
//             name: "Team Members",
//             listPath: "teamMembers",
//             newPath: "teamMember",
//             superOnly: true,
//             svg: svgTeamMembers,
//         },  {
//             name: "Sellers",
//             listPath: "sellers",
//             newPath: "seller",
//             superOnly: true,
//             svg: svgSellers,
//         }, {
//             name: "Buyers",
//             listPath: isSuper ? "buyers" : "buyers?STATUS=1031-Buyer%2CActive",
//             newPath: "buyer",
//             superOnly: false,
//             svg: svgBuyers,
//         }, {
//             name: "Agents",
//             listPath: "agents",
//             newPath: "agent",
//             superOnly: true,
//             svg: svgAgents,
//         }, {
//             name: "Firms",
//             listPath: "firms",
//             newPath: "firm",
//             superOnly: true,
//             svg: svgFirms,
//         }, {
//             name: "Tenants",
//             listPath: "tenants",
//             newPath: "tenant",
//             superOnly: true,
//             svg: svgTenants,
//         }, {
//             name: "Lenders",
//             listPath: "lenders",
//             newPath: "lender",
//             superOnly: true,
//             svg: svgLenders,
//         }, {
//             name: "Uploads",
//             listPath: "upload-file",
//             superOnly: true,
//             svg: svgUploads,
//         }, {
//             name: "Training",
//             listPath: "training",
//             svg: svgTrainingPages,
//         }, 
//         {
//             name: "ROVER",
//             listPath: "striveVision",
//             superOnly: false,
//             svg: svgEyeOpen,
//         }, 
//     ];
// };

// const strivePipelineLinks = [
//     {
//         url: "agent-commission-breakdown",
//         name: "Agent Commission",
//         svg: svgAgentCommissionBreakdown,
//     },
//     {
//         url: "agent-pipeline",
//         name: "Agent Pipeline",
//         svg: svgAgentPipeline,
//     }, {
//         url: "buckets",
//         name: "Buckets",
//         svg: svgBuckets,
//     }, {
//         url: "inventory",
//         name: "Inventory",
//         svg: svgInventory,
//     }, {
//         url: "escrow-tracking",
//         name: "Escrow Tracking",
//         svg: svgEscrowTracking,
//     }, {
//         url: "pipeline",
//         name: "Pipeline",
//         svg: svgPipeline,
//     }, {
//         url: "strive-fees",
//         name: "STRIVE Fees",
//         svg: svgStriveFees,
//     },
// ];

// const hscPipelineLinks = [
//     {
//         url: "hsc-pipeline",
//         name: "Pipeline",
//         svg: svgHscPipeline,
//     }, {
//         url: "hsc-tracking",
//         name: "Tracking",
//         svg: svgHscTracking,
//     },{
//         url: "hsc-stats",
//         name: "Stats",
//         svg: svgStats,
//     },
// ]

// const crmLinks = [
//     {
//         url: "contacts",
//         name: "Contacts",
//         svg: svgContacts,
//     },
//     {
//         url: "company",
//         name: "Company",
//         svg: svgCompany,
//     },
// ]

// export default class Sidebar extends React.Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             isOpen: false,
//             isOpenStrivePipeline: false,
//             isOpenHscPipeline: false,
//             isCrmOpen:false,
//         };
//         this.setState = this.setState.bind(this);
//         this.handleCollapse = this.handleCollapse.bind(this);
//         this.handleCollapseStrivePipeline = this.handleCollapseStrivePipeline.bind(this);
//         this.handleCollapseHscPipeline = this.handleCollapseHscPipeline.bind(this);
//         this.handleCollapseCRM = this.handleCollapseCRM.bind(this)
//         this.onLinkHover = this.onLinkHover.bind(this);
//     }

//     handleCollapse() {
//         this.setState((prevState) => ({isOpen: !prevState.isOpen}));
//     }

//     handleCollapseStrivePipeline() {
//         this.setState((prevState) => ({
//             isOpenStrivePipeline: !prevState.isOpenStrivePipeline,
//         }));
//     }

//     handleCollapseHscPipeline() {
//         this.setState((prevState) => ({
//             isOpenHscPipeline: !prevState.isOpenHscPipeline,
//         }));
//     }
//     handleCollapseCRM() {
//         this.setState((prevState) => ({
//             isCrmOpen: !prevState.isCrmOpen,
//         }));
//     }


//     onLinkHover(e) {
//         if (!this.state.isOpen) {
//             let menuItem = e.currentTarget;
//             let wrapper = menuItem.querySelector("div");
//             let tooltip = wrapper.children[1];
//             tooltip.style.top = menuItem.getBoundingClientRect().top + "px";
//         }
//     }

//     render() {
//         const {signOut, pathname, isSuper, isHscUser} = this.props;
//         const links = getLinks(isSuper);
//         const {isOpen,isCrmOpen} = this.state;
//         const path = pathname.includes('/') ? pathname.split('/')[1] : pathname;

//         return signOut ?
//             (<div className="Body-wrapper">
//                 <div className={`Sidebar ${isOpen ? "open" : "closed"}`}>
//                     <ul className="Sidebar_list">
//                         <li className="Sidebar_item first">
//                             <div className="item-wrapper">
//                                 <div className="Sidebar_item_link" onClick={this.handleCollapse}>
//                                     <Icon svg={isOpen ? svgCollapse : svgExpand}/>
//                                     <div className="Sidebar_item_link_name">Collapse menu</div>
//                                 </div>
//                                 {isOpen ? null : <span className="tooltip">Expand menu</span>}
//                             </div>
//                         </li>
//                         <li className="Sidebar_item" onMouseOver={this.onLinkHover}>
//                             <div className="item-wrapper">
//                                 <LinkComp className={"Sidebar_item_link" + ((!isHscUser && arc.path.base === pathname) || (isHscUser && '/stats' === pathname) ? " Sidebar_item_link--active" : "")}
//                                           to={isHscUser ? 'stats' : arc.path.base}>
//                                     <Icon svg={svgStats}/>
//                                     <div className="Sidebar_item_link_name">Stats</div>
//                                 </LinkComp>
//                                 {isOpen ? null : <span className="tooltip">Stats</span>}
//                             </div>
//                         </li>
//                         {isSuper
//                             ? links.map((x, i) => (
//                                 <li className={`Sidebar_item ${i === links.length - 1 ? "last" : ""}`}
//                                     key={i}
//                                     onMouseOver={this.onLinkHover}>
//                                     <div className="item-wrapper">
//                                         <LinkComp className={`Sidebar_item_link ${isOpen ? "" : "closed-sidebar"}` +
//                                                     ([x.listPath.includes('?') ? x.listPath.split('?')[0] : x.listPath, x.newPath].includes(path)
//                                                         ? " Sidebar_item_link--active" : "")}
//                                                   to={arc.path.base + x.listPath}>
//                                             <Icon svg={x.svg}/>
//                                             <div className="Sidebar_item_link_name">{x.name}</div>
//                                         </LinkComp>
//                                         {isOpen ? null : (<span className="tooltip">{x.name}</span>)}
//                                         {x.newPath &&
//                                             <LinkComp className="New-button"
//                                                       to={arc.path.base + x.newPath}>
//                                                 <Icon svg={plus}/>
//                                             </LinkComp>
//                                         }
//                                     </div>
//                                 </li>
//                             ))
//                             : links.map((x, i) => {
//                                 if (!x.superOnly) {
//                                     return (
//                                         <li className={`Sidebar_item ${i === links.length - 1 ? "last" : ""}`}
//                                             key={i}
//                                             onMouseOver={this.onLinkHover}>
//                                             <div className="item-wrapper">
//                                                 <LinkComp
//                                                     className={`Sidebar_item_link ${isOpen ? "" : "closed-sidebar"}` +
//                                                         ([x.listPath.includes('?') ? x.listPath.split('?')[0] : x.listPath, x.newPath].includes(path)
//                                                             ? " Sidebar_item_link--active" : "")}
//                                                     to={arc.path.base + x.listPath}>
//                                                     <Icon svg={x.svg}/>
//                                                     <div className="Sidebar_item_link_name">
//                                                         {x.name}
//                                                     </div>
//                                                 </LinkComp>
//                                                 {isOpen ? null : (<span className="tooltip">{x.name}</span>)}
//                                             </div>
//                                         </li>
//                                     );
//                                 }
//                             })}
//                         <PipelineDropdown pipelineLinks={strivePipelineLinks}
//                                           name='Strive pipeline'
//                                           isSidebarOpen={isOpen}
//                                           isPipelineOpen={this.state.isOpenStrivePipeline}
//                                           svg={svgStrivePipeline}
//                                           path={path}
//                                           onLinkHover={this.onLinkHover}
//                                           handleCollapsePipeline={this.handleCollapseStrivePipeline}
//                         />
//                         <PipelineDropdown pipelineLinks={hscPipelineLinks}
//                                           name='Hsc pipeline'
//                                           isSidebarOpen={isOpen}
//                                           isPipelineOpen={this.state.isOpenHscPipeline}
//                                           svg={svgHsc}
//                                           path={path}
//                                           onLinkHover={this.onLinkHover}
//                                           handleCollapsePipeline={this.handleCollapseHscPipeline}
//                         />
//                         <PipelineDropdown pipelineLinks={crmLinks}
//                                           name='CRM'
//                                           isSidebarOpen={isOpen}
//                                           isPipelineOpen={isCrmOpen}
//                                           svg={svgCRM}
//                                           path={path}
//                                           onLinkHover={this.onLinkHover}
//                                           handleCollapsePipeline={this.handleCollapseCRM}
//                         />
//                         <li className="Sidebar_item signout">
//                             <div className="item-wrapper">
//                                 <LinkComp className="Sidebar_item_link"
//                                           to={arc.path.base}
//                                           onClick={signOut}>
//                                     <Icon svg={svgSignout}/>
//                                     <div className="Sidebar_item_link_name">Sign out</div>
//                                 </LinkComp>
//                                 {isOpen ? null : <span className="tooltip">Sign out</span>}
//                             </div>
//                         </li>
//                     </ul>
//                 </div>
//                 <div className={`Body-wrapper_content ${isOpen ? "wrapper-open" : "wrapper-closed"}`}>
//                     {this.props.children}
//                 </div>
//             </div>)
//             :
//             (this.props.children);
//     }
// }





import * as React from "react";
import Icon from "../Icon/";
import LinkComp from "../LinkComp";
import svgBuyers from "../../svgs/Buyers.svg";
import svgStats from "../../svgs/Stats.svg";
import svgProperties from "../../svgs/Properties.svg";
import svgSellers from "../../svgs/Sellers.svg";
import svgAgents from "../../svgs/Agents.svg";
import svgFirms from "../../svgs/Firms.svg";
import svgTenants from "../../svgs/Tenants.svg";
import svgLenders from "../../svgs/Lenders.svg";
import svgUploads from "../../svgs/Upload.svg";
import svgSignout from "../../svgs/Signout.svg";
import svgExpand from "../../svgs/Expand.svg";
import svgCollapse from "../../svgs/collapse.svg";
import svgStrivePipeline from "../../svgs/StrivePipeline.svg";
import svgAgentCommissionBreakdown from "../../svgs/AgentCommissionBreakout.svg";
import svgAgentPipeline from "../../svgs/AgentPipeline.svg";
import svgBuckets from "../../svgs/Buckets.svg";
import svgInventory from "../../svgs/Inventory.svg";
import svgEscrowTracking from "../../svgs/EscrowTracking.svg";
import svgPipeline from "../../svgs/Pipeline.svg";
import svgStriveFees from "../../svgs/Fees.svg";
import svgHscPipeline from "../../svgs/HscPipeline.svg";
import svgHscTracking from "../../svgs/HSCTracking.svg";
import svgTrainingPages from "../../svgs/TrainingPages.svg";
import svgSymposium from "../../svgs/symposium.svg"
import plus from '../../svgs/plus-dark.svg';
import PipelineDropdown from "../PipelineDropdown/PipelineDropdown";
import svgHsc from "../../svgs/HSC.svg";
import svgTeamMembers from "../../svgs/TeamMembers.svg";
import svgEyeOpen from "../../svgs/location.svg";
import svgCRM from "../../svgs/CRM.svg"
import svgContacts from "../../svgs/Contacts.svg"
import svgCompany from "../../svgs/Company.svg"
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import svgPassword from "../../svgs/change_password.svg"
import svgUserRegisteration from "../../svgs/userRegisetration.svg"
import svgHscFollowUp from "../../svgs/hscFollowUp.svg"


import proposal from "../../svgs/proposal.svg";
import svgVendors from "../../svgs/Vendor.svg";
import websiteSvg from "../../svgs/web-svgrepo-com.svg"
import newsSvg from "../../svgs/news-svgrepo-com.svg"
import eventSvg from "../../svgs/event-svgrepo-com.svg"
import { isAgentUser, isAuthorizedUserForWebsiteChanges, isSeniorAgent } from "../../utils";


 const storedUserData = JSON.parse(sessionStorage.getItem("userData") || "{}");
 const isAgentRestrictedUser  =  isAgentUser(storedUserData)
const getLinks = (email) => {
  let links =  [ 
    {
    name: "ROVER",
    listPath: "rover",
    superOnly:isAgentRestrictedUser ? true : false,
    restrictedUsersOnly: true,
     superOnly: true,
    svg: svgEyeOpen,
  },
  {
    name: "Properties",
    listPath: "list?source=STRIVE&status=Active&transaction_type=Investment+Sales",
    // SOURCE=STRIVE&STATUS=Active&TRANSACTION_TYPE=Investment+Sales",
    newPath: "property",
    restrictedUsersOnly: true,
    superOnly: false,
    svg: svgProperties,
  },
  //  {
  //   name: "Team Members",
  //   listPath: "teamMembers",
  //   newPath: "teamMember",
  //   superOnly: true,
  //   svg: svgTeamMembers,
  // }, 
  // {
  //   name: "Vendors",
  //   listPath: "vendors",
  //   newPath: "vendors",
  //   superOnly: true,
  //   svg: svgVendors,
  // },
  // {
  //   name: "Investors",
  //   listPath: "investors",
  //   newPath: "investor",
  //   superOnly: true,
  //   svg: svgBuyers,
  // },
  // {
  //   name: "Sellers",
  //   listPath: "sellers",
  //   newPath: "seller",
  //   superOnly: true,
  //   svg: svgSellers,
  // }, {
  //   name: "Buyers",
  //   listPath: isSuper ? "buyers" : "buyers?STATUS=1031-Buyer%2CActive",
  //   newPath: "buyer",
  //   superOnly: false,
  //   svg: svgBuyers,
  // }, 
  // {
  //   name: "Agents",
  //   listPath: "agents",
  //   newPath: "agent",
  //   superOnly: true,
  //   svg: svgAgents,
  // }, {
  //   name: "Companies",
  //   listPath: "firms",
  //   newPath: "firm",
  //   superOnly: true,
  //   svg: svgFirms,
  // }, {
  //   name: "Tenants",
  //   listPath: "tenants",
  //   newPath: "tenant",
  //   superOnly: true,
  //   svg: svgTenants,
  // }, {
  //   name: "Lenders",
  //   listPath: "lenders",
  //   newPath: "lender",
  //   superOnly: true,
  //   svg: svgLenders,
  // }, 
  ];
  if (isAuthorizedUserForWebsiteChanges(email)) {
    links.push({
      name: "Proposals",
      listPath: "proposals",
      newPath: "proposal",
      superOnly: false,
      svg: proposal,
    })
  }

  links.push(
    {
      name: "Uploads",
      listPath: "upload-file",
      superOnly: true,
      svg: svgUploads,
    }, 
    {
      name: "Training",
      listPath: "training",
      svg: svgTrainingPages,
      restrictedUsersOnly: true,
    },
     {
      name: "Symposium",
      listPath: "symposium",
      svg: svgSymposium,
      restrictedUsersOnly: true,
    },
    //  {
    //   name: "Users",
    //   newPath: "users",
    //   listPath: "userList",
    //   superOnly: true,
    //   svg: svgUserRegisteration,
    // }
  )
  return links
};

const strivePipelineLinks = [
  {
    url: "agent-commission-breakdown",
    name: "Agent Commission",
    svg: svgAgentCommissionBreakdown,
  },
  {
    url: `agent-commission-breakdown/${new Date().getFullYear()}/14/paid`,
    name: "Paid and Procured",
    svg: svgLenders,
  },
  {
    url: "agent-pipeline",
    name: "Agent Pipeline",
    svg: svgAgentPipeline,
  }, {
    url: "buckets",
    name: "Buckets",
    svg: svgBuckets,
  }, {
    url: "inventory",
    name: "Inventory",
    svg: svgInventory,
  }, {
    url: "escrow-tracking",
    name: "Escrow Tracking",
    svg: svgEscrowTracking,
  }, {
    url: "pipeline",
    name: "Pipeline",
    svg: svgPipeline,
  }, {
    url: "strive-fees",
    name: "STRIVE Fees",
    svg: svgStriveFees,
  },
];

const hscPipelineLinks = [
  {
    url: "hsc-pipeline",
    name: "Pipeline",
    svg: svgHscPipeline,
  }, {
    url: "hsc-tracking",
    name: "Tracking",
    svg: svgHscTracking,
  }, {
    url: "hsc-stats",
    name: "Stats",
    svg: svgStats,
  },{
    url: "hsc-hotlist",
    name: "AthCap - Hot List",
    className: "hsc-hotlist",
    svg: svgHscFollowUp,
},
]

const websiteLinks = [
  {
     url: "events",
     name: "Events",
     svg: eventSvg,
 },
 {
     url: "news-list",
     name: "News",
     svg: newsSvg,
 }
]

const crmLinks = [
     {
        url: "company",
        name: "Companies",
        svg: svgCompany,
         superOnly: true,
    },
    {
        url: "contacts",
        name: "Contacts",
         superOnly: true,
        svg: svgContacts,
    },
      {
        url: "contacts/investors",
        name: "Investors",
        superOnly: true,
        svg: svgBuyers,
        newPath: "investor",
    },
      {
        url: "contacts/agents",
        name: "Agents",
        superOnly: true,
        svg: svgAgents,
        newPath: "agent",
    },
      {
        url: "contacts/vendors",
        name: "Vendors",
        superOnly: true,
        svg: svgVendors,
        newPath: "vendor",
    },
     {
        url: "contacts/tenants",
        name: "Tenants",
        superOnly: true,
       svg: svgLenders,
       newPath: "tenant",
    },
    
     
    //   {
    //     url: "company/firms",
    //     name: "Companies",
    //     superOnly: true,
    //     svg: svgContacts,
    //     svg: svgFirms
    // },
     {
        url: 'contacts/team-members',
        name: 'Team Members',
        superOnly: true,
        svg: svgContacts,
        svg: svgTeamMembers,
        newPath: "teamMember",
    },
      {
        url: "contacts/lenders",
        name: "Lenders",
        svg: svgContacts,
        newPath: "lender",
    },

]
const options = [
  'Investors',
   'Agents',
    'Vendors',
     'Lenders',
   'Tenants',
  'Companies',
  'Team Members',
  
  // 'Sellers',
  // 'Buyers',
];

const ITEM_HEIGHT = 48;

export default class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      isOpenStrivePipeline: false,
      isOpenHscPipeline: false,
      isCrmOpen: false,
      isHoverCrm: false,
      anchorEl: null,
      isCrmMenu: null,
      isHoverCrmMenu:false,
      isOpenWebsite: false
    };
    this.setState = this.setState.bind(this);
    this.handleCollapse = this.handleCollapse.bind(this);
    this.handleCollapseStrivePipeline = this.handleCollapseStrivePipeline.bind(this);
    this.handleCollapseHscPipeline = this.handleCollapseHscPipeline.bind(this);
    this.handleCollapseCRM = this.handleCollapseCRM.bind(this)
    this.onLinkHover = this.onLinkHover.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handlePopUpLeave = this.handlePopUpLeave.bind(this);
    this.extractContactType = this.extractContactType.bind(this);
    this.handleCollapseWebsite = this.handleCollapseWebsite.bind(this);
  }

    handleCollapse() {
      this.setState(
    (prevState) => ({ isOpen: !prevState.isOpen }),
    () => {
      // Callback after state has been updated
      sessionStorage.setItem("isOpenSidebar", JSON.stringify(this.state.isOpen));
    }
  );
    }

    handleCollapseStrivePipeline() {
        this.setState((prevState) => ({
            isOpenStrivePipeline: !prevState.isOpenStrivePipeline,
        }));
    }

    handleCollapseWebsite() {
      this.setState((prevState) => ({
          isOpenWebsite: !prevState.isOpenWebsite,
      }));
  }

    

  handleCollapseHscPipeline() {
    this.setState((prevState) => ({
      isOpenHscPipeline: !prevState.isOpenHscPipeline,
    }));
  }
  handleCollapseCRM() {
    this.setState((prevState) => ({
      isCrmOpen: !prevState.isCrmOpen,
    }));
  }
handlePopUpLeave(){
  this.setState({
    isHoverCrmMenu:false
  });
}

handleMouseEnter(){
  this.setState({isHoverCrmMenu:true})
 }




  renderCrmSubComp(option) {
    const formattedOption = option.replace(/\s+/g, "-").toLowerCase(); // Replace spaces with dashes and lowercase
    const baseUrl = location.origin;

    // Check if the option is 'Firms' and redirect accordingly
    const url = option === "Companies"
      ? `${baseUrl}/company/firms`
      : `${baseUrl}/contacts/${formattedOption}`;

    window.location.href = url;
  }



  onLinkHover(e) {
            if (!this.state.isOpen) {
                let menuItem = e.currentTarget;
                let wrapper = menuItem.querySelector("div");
                let tooltip = wrapper.children[1];
                tooltip.style.top = menuItem.getBoundingClientRect().top + "px";
            }
        }
        
 extractContactType(pathname) {
  // Remove leading and trailing slashes
  const cleanPath = pathname.replace(/^\/|\/$/g, "");
  const segments = cleanPath.split("/");

  if (segments.length >= 2) {
    // Return first two segments
    return `${segments[0]}/${segments[1]}`;
  } else if (segments.length === 1 && segments[0]) {
    // If only one valid segment like 'contacts' or 'company'
    return segments[0];
  }

  // Fallback (e.g. empty path)
  return null;
}




  render() {
    const { signOut, pathname, isSuper, isHscUser, updatePassword } = this.props;
    const links = getLinks(this.props.userData.email);
    const filteredLinks = links.filter(link => {
  if (link.superOnly && !isSuper) return false;
  if (link.restrictedUsersOnly && isAgentUser(this.props.userData)) return false;
  return true;
});
    const { isOpen, isCrmOpen, isHoverCrm, anchorEl ,isHoverCrmMenu} = this.state;
    const isCrmContactUrl = this.extractContactType(pathname)
    // const path = pathname.includes('/') ? pathname.split('/')[1] : pathname;
    const isLinkAgentCommission = pathname.includes('agent-commission-breakdown') && pathname.split('/').length > 2;
    const path = isCrmContactUrl
  ? isCrmContactUrl : (!isLinkAgentCommission ?  (pathname.includes('/') ? pathname.split('/')[1] : pathname) :(pathname.replace('/', '')));

    return signOut ? (
      <div className="Body-wrapper">
        <div className={`Sidebar ${isOpen ? "open" : "closed"}`}>
          <ul className="Sidebar_list">
            <li className="Sidebar_item first">
              <div className="item-wrapper">
                <div
                  className="Sidebar_item_link"
                  onClick={this.handleCollapse}
                >
                  <Icon svg={isOpen ? svgCollapse : svgExpand} />
                  <div className="Sidebar_item_link_name">
                    Collapse menu
                  </div>
                </div>
                {isOpen ? null : (
                  <span className="tooltip">Expand menu</span>
                )}
              </div>
            </li>
             { !isAgentUser(this.props.userData) &&
            <li className="Sidebar_item" onMouseOver={this.onLinkHover}>
       <div className="item-wrapper">
                <LinkComp
                  className={
                    "Sidebar_item_link" +
                    ((!isHscUser && arc.path.base === pathname) ||
                      (isHscUser && "/stats" === pathname)
                      ? " Sidebar_item_link--active"
                      : "")
                  }
                  to={isHscUser ? "stats" : arc.path.base}
                >
                  <Icon svg={svgStats} />
                  <div className="Sidebar_item_link_name">Stats</div>
                </LinkComp>
                {isOpen ? null : <span className="tooltip">Stats</span>}
              </div>
            </li>}
            { filteredLinks.map((x, i) => (
                  <React.Fragment key={i}>
                    <li
                      className={`Sidebar_item ${
                        i === filteredLinks.length - 1 ? "last" : ""
                      }`}
                      onMouseOver={this.onLinkHover}
                    >
                      <div className="item-wrapper">
                        <LinkComp
                          className={
                            `Sidebar_item_link ${
                              isOpen ? "" : "closed-sidebar"
                            }` +
                            ([
                              x.listPath.includes("?")
                                ? x.listPath.split("?")[0]
                                : x.listPath,
                              x.newPath,
                            ].includes(path)
                              ? " Sidebar_item_link--active"
                              : "")
                          }
                          to={arc.path.base + x.listPath}
                        >
                          <Icon svg={x.svg} />
                          <div className="Sidebar_item_link_name">{x.name}</div>
                        </LinkComp>
                        {isOpen ? null : (
                          <span className="tooltip">{x.name}</span>
                        )}
                        { x.newPath && (
                          <LinkComp
                            onClick={()=>{
                           sessionStorage.setItem("isCrmback", `${x.newPath}|${x.url}`);
                        }}
                            className="New-button"
                            to={arc.path.base + x.newPath}
                          >
                            <Icon svg={plus} />
                          </LinkComp>
                        )}
                      </div>
                    </li>

                    {/* Insert CRM below ROVER */}
                    {x.name === "ROVER" && (
     
                   <li 
  style={{
        marginLeft: isOpen ? "23px" : "0px",
  }}
>
 
   { ! isAgentUser(this.props.userData) && <PipelineDropdown
      data-item="crm"
      onMouseCrmEnter={this.handleMouseEnter}
      pipelineLinks={crmLinks}
      name="CRM"
      isSidebarOpen={isOpen}
      isPipelineOpen={isCrmOpen}
      svg={svgCRM}
      path={path}
      onLinkHover={this.onLinkHover}
      handleCollapsePipeline={this.handleCollapseCRM}
    /> }
</li>
                    )}
                  </React.Fragment>
                ))}
          { ! isAgentUser(this.props.userData)  && 
            <PipelineDropdown
              pipelineLinks={strivePipelineLinks}
              name="Strive pipeline"
              isSidebarOpen={isOpen}
              isPipelineOpen={this.state.isOpenStrivePipeline}
              svg={svgStrivePipeline}
              path={path}
              onLinkHover={this.onLinkHover}
              handleCollapsePipeline={this.handleCollapseStrivePipeline}
            /> }
            { !isAgentUser(this.props.userData) && !isSeniorAgent(this.props.userData) &&   <PipelineDropdown
              pipelineLinks={hscPipelineLinks}
              name="AthCap pipeline"
              isSidebarOpen={isOpen}
              isPipelineOpen={this.state.isOpenHscPipeline}
              svg={svgHsc}
              path={path}
              onLinkHover={this.onLinkHover}
              handleCollapsePipeline={this.handleCollapseHscPipeline}
            />}

          {isAuthorizedUserForWebsiteChanges(this.props.userData.email) && <PipelineDropdown
              pipelineLinks={websiteLinks}
              name="Website"
              isSidebarOpen={isOpen}
              isPipelineOpen={this.state.isOpenWebsite}
              svg={websiteSvg}
              path={path}
              onLinkHover={this.onLinkHover}
              handleCollapsePipeline={this.handleCollapseWebsite}
            />}

            {/* {isHoverCrmMenu && isOpen ? (
              <div>
                <Menu
                  id="long-menu"
                  MenuListProps={{
                    onMouseLeave: this.handlePopUpLeave,
                    "aria-labelledby": "long-button",
                    style: {
                      padding: "0",
                      backgroundColor: "black !important",
                    },
                  }}
                  anchorEl={isHoverCrmMenu}
                  open={Boolean(isHoverCrmMenu)}
                  onClose={this.handlePopUpLeave}
                  PaperProps={{
                    style: {
                      maxHeight: "160px !important", // Reduced height to show 4 items at a time (40px per item)
                      minHeight: "auto !important",
                      width: "200px !important",
                      transform: "translate(120px, -130px)", // Adjusted positioning
                      borderRadius: "10px !important",
                      overflowY: "auto !important", // Enable vertical scrolling
                      overflowX: "hidden !important", // Hide horizontal scroll
                      backgroundColor: "black !important",
                      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2) !important",
                    },
                  }}
                  sx={{
                    "& .MuiPaper-root": {
                      scrollbarWidth: "thin !important", // Thin scrollbar for Firefox
                      "&::-webkit-scrollbar": {
                        width: "8px !important", // Thin scrollbar width for webkit browsers
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "transparent !important", // Invisible thumb
                        borderRadius: "10px !important", // Rounded thumb
                      },
                      "&::-webkit-scrollbar-track": {
                        backgroundColor: "transparent !important", // Invisible track
                      },
                    },
                  }}
                >
                  {options.map((option) => (
                    <MenuItem
                      key={option}
                      sx={{
                        color: "#959595 !important",
                        backgroundColor: "black !important",
                        whiteSpace: "nowrap !important",
                        padding: "10px 16px !important",
                        width: "100% !important",
                        display: "block !important",
                        "&:hover": {
                          color: "#90C54B !important",
                          backgroundColor: "#222 !important",
                        },
                        transition: "all 0.3s ease !important",
                      }}
                      selected={option === "Pyxis"}
                      onClick={() => this.renderCrmSubComp(option)}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </Menu>
              </div>
            ) : null} */}

            {/* </div> */}
            
            <li className="Sidebar_item updatePassword">
              <div className="item-wrapper">
                <div
                  className="Sidebar_item_link"
                  onClick={updatePassword}
                  style={{ cursor: 'pointer' }}
                >
                  <Icon svg={svgPassword} />
                  <div className="Sidebar_item_link_name">Change Password</div>
                </div>
                {isOpen ? null : <span className="tooltip">Change Password</span>}
              </div>
            </li>

            <li className="Sidebar_item signout">
              <div className="item-wrapper">
                <LinkComp
                  className="Sidebar_item_link"
                  to={arc.path.base}
                  onClick={signOut}
                >
                  <Icon svg={svgSignout} />
                  <div className="Sidebar_item_link_name">Sign out</div>
                </LinkComp>
                {isOpen ? null : <span className="tooltip">Sign out</span>}
              </div>
            </li>
          </ul>
        </div>
        <div
          className={`Body-wrapper_content ${isOpen ? "wrapper-open" : "wrapper-closed"
            }`}
        >
          {this.props.children}
        </div>
      </div>
    ) : (
      this.props.children
    );
  }
}